// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".light-toggle{display:flex;align-items:center;margin:8px 0;position:relative;color:var(--hb-font-color)}.light-toggle--active .light-toggle__icon svg{fill:#242424;transition:left .15s cubic-bezier(0,.55,.45,1) 50ms}.light-toggle__icon{display:block;margin-right:8px}.light-toggle__icon svg{top:50%;fill:#7e7e7e;transition:left .15s cubic-bezier(0,.55,.45,1) 50ms}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
